import React from 'react';
import { gql } from '@soundxyz/gql-string';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment } from '@graphql/reactQuery';
import { TopCommentCardFragmentDoc } from '@graphql/reactQuery';
import { BlackCommentCard } from './BlackCommentCard';
/*#__PURE__*/ gql(/* GraphQL */ `
  fragment TopCommentCard on ReleaseCollector {
    id
    user {
      id
      artist {
        id
      }
      username
      publicAddress
      webappUri
      avatar {
        id
        url
      }
    }
    nftsCount
    gaNftsCount
    vipNftsCount
    firstNftCollectedDate
    mostRecentNftWithComment {
      id
      comment {
        id
        message
      }
    }
  }
`);

export const TopCommentCard = ({ data }: { data: FragmentType<TopCommentCardFragmentDoc> }) => {
  const {
    user: { username, publicAddress, artist, webappUri, avatar },
    nftsCount,
    mostRecentNftWithComment,
  } = getFragment(TopCommentCardFragmentDoc, data);
  return (
    <BlackCommentCard
      username={username}
      comment={mostRecentNftWithComment?.comment?.message}
      publicAddress={publicAddress}
      totalEditions={nftsCount}
      avatarUrl={avatar?.url}
      isArtist={artist != null}
      webappUri={webappUri}
      audience
    />
  );
};
